import React from 'react';
import { Track, Fill } from './ratingBar.styled';

interface RatingBarProps {
	rating: number;
	$height?: string;
	$rounded?: boolean;
	$barColor?: string;
	$barBackground?: string;
	$width: number;
}

const RatingBar: React.FC<RatingBarProps> = ({
	rating,
	$height = '8px',
	$rounded = true,
	$barColor,
	$barBackground,
	$width,
}) => {
	const percent = Math.max(0, Math.min(100, (rating / 10) * 100));

	return (
		<Track
			$width={$width}
			$height={$height}
			$rounded={$rounded}
			$barBackground={$barBackground}
			aria-label={`Rating ${rating}/10`}
		>
			<Fill $percent={percent} $height={$height} $barColor={$barColor} />
		</Track>
	);
};

export default RatingBar;
